import { AggregatedSales, calculateMenuStats } from "../types/aggregatedSales";
import { AggregatedSalesApi } from "../types/aggregatesSalesApi";
import { isError } from "../utilities/typeguards";
import { baseFetch, HttpVerbs } from "./baseFetch";
import { endpoints } from "./endpoints";

type FetchAggregatesSalesParams = {
  siteId: number;
  orgId: string;
  searchPeriod: { from: string; to: string };
};

const fetchAggregatedSales = async (
  params: FetchAggregatesSalesParams
): Promise<AggregatedSales[]> => {
  const url = `${endpoints.getSalesAggregate}?regionID=1&siteId=${params.siteId}&dateFrom=${params.searchPeriod.from}&dateTo=${params.searchPeriod.to}`;
  const response = await baseFetch<AggregatedSalesApi[]>({
    endpointUrl: url,
    httpVerb: HttpVerbs.GET,
    orgId: params.orgId,
  });
  if (isError(response)) {
    // do error handling here - show a toast or something
    throw new Error(`Error fetching aggregated sales data ${response}`);
  }

  return response.map((sale) => {
    return {
      ...sale,
      Level1MenuAggregateStatistics: calculateMenuStats(
        sale.Items,
        "Level1MenuID"
      ),
      Level2MenuAggregateStatistics: calculateMenuStats(
        sale.Items,
        "Level2MenuID"
      ),
      Level3MenuAggregateStatistics: calculateMenuStats(
        sale.Items,
        "Level3MenuID"
      ),
    };
  });
};

export { fetchAggregatedSales };

